<div class="consolidated-series-audit-history">
  <div class="row auto space-between">
    <utils-bar [search]="true"
               (searchValueSubmitted)="applyFilter($event)"
               (searchCleared)="filterString='';applyFilter($event)">
    </utils-bar>
    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200]" [pageSize]="pageSize" style="align-items: center;"
                   length="{{data ? data.length : 0}}" showFirstLastButtons="true"></mat-paginator>
  </div>

  @if (loading) {
    <div class="stage">
      <div class="dot-flashing"></div>
    </div>
  }
  @if (!loading && dataSource?.data?.length) {

    <div class="table-container">
      <table [dataSource]="dataSource"
             class="table striped-table series-audit-history-table" mat-table matSort style="width:100%;"
             matSortActive="timestamp" matSortDirection="desc" multiTemplateDataRows="true">

        @for (column of columns; track column) {
          @if (column !== 'expand') {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell>
                {{column | upperfirst | removeUnderscore}}
              </th>
              @if (!['comments'].includes(column)) {
                <td *matCellDef="let item;" mat-cell>
                  @if (column === 'changed_on') {
                    <span>{{item[column] | stringDate}}</span>
                  }
                  @if (column === 'timestamp') {
                    <div class="timestamp-row">
                      <span>{{item[column] | stringDate}}</span>
                      <span (click)="loadSubHourlyData(item)" class="sub-hourly-click material-symbols-outlined"
                            matTooltip="Click to view sub hourly data">timer</span>
                    </div>
                  }
                  @if (column === 'changed_by') {
                    <ng-container class="row center">
                      <span>{{item[column]}}</span>
                    </ng-container>
                  }
                  @if (['value', 'old_value'].includes(column)) {
                    <ng-container class="row center">
                      <span>{{item[column] | formatNumber:series.attributes?.decimal_places: true}}</span>
                    </ng-container>
                  }
                </td>
              }
              @if (column === 'comments') {
                <td *matCellDef="let item;" mat-cell>
                  <div style="max-height:80px;overflow-y:auto;">
                    @for (comment of item.comments; track comment) {
                      <div>{{comment}}</div>
                    }
                  </div>
                </td>
              }
            </ng-container>
          }
          @if (column === 'expand') {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell></th>
              <td *matCellDef="let item;" mat-cell class="hideonprint">
                <div (click)="toggleRow(item)"
                     [matTooltip]="expandedElement[item.id] ? 'Hide sub-hourly statistics' : 'Show sub-hourly statistics'">
              <span class="material-symbols-outlined arrow">
              {{expandedElement[item.id] ? 'arrow_drop_down' : 'arrow_right'}}</span>
                </div>
              </td>
            </ng-container>
          }
        }


        <ng-container matColumnDef="expandedDetail">
          <td *matCellDef="let item" [attr.colspan]="columns.length" mat-cell>
            @if (expandedElement[item.id] === true) {
              <div class="series-audit-statistics">
                <series-audit-statistics [seriesId]="series.id" [timestamp]="item.timestamp"></series-audit-statistics>
              </div>
            }
          </td>
        </ng-container>

        <tr *matHeaderRowDef="columns; " mat-header-row></tr>


        <tr *matRowDef="let row; columns: columns;"
            [class.main-row-detail-expanded]="expandedElement[row.id]"
            mat-row>
        </tr>
        <tr *matRowDef="let row; columns: ['expandedDetail'];"
            [class.detail-not-expanded]="!expandedElement[row.id]"
            class="statistics-row"
            mat-row></tr>

      </table>

      @if (!loading && dataSource && dataSource.data.length === 0) {
        <div class="no-data-message">
          No data available for this period
        </div>
      }
    </div>
  }
</div>
